import React, { createContext, useState, useContext } from 'react';

// File name must be unique accross all v3, frontend and backend
import CommonTrans from './common-translations.json';
import OrgPageTrans from './views/org/org-translations.json';

const translations = {
  Common: CommonTrans,
  OrgPage: OrgPageTrans,
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en'); // Default to English

  const translate = (component, key) => {
    // First try to get the translation for the current language
    const translation = translations[component]?.[language]?.[key];
    
    // If translation exists, return it
    if (translation) {
      return translation;
    }
    
    // If no translation found for current language, fallback to English
    if (language !== 'en') {
      const englishTranslation = translations[component]?.['en']?.[key];
      if (englishTranslation) {
        return englishTranslation;
      }
    }
    
    // If no translation found at all, return the key
    return key;
  };

  // Get available languages from the translation files
  const getAvailableLanguages = () => {
    const languages = new Set();
    Object.values(translations).forEach(translationFile => {
      Object.keys(translationFile).forEach(lang => languages.add(lang));
    });
    return Array.from(languages);
  };

  return (
    <LanguageContext.Provider value={{ 
      language, 
      setLanguage, 
      translate, 
      availableLanguages: getAvailableLanguages() 
    }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useTranslation = () => {
  return useContext(LanguageContext);
};

